import { CustomerAccount } from 'utils/api/models/accounts/customerAccountResponse';
import { SingleResource } from 'utils/api/models/resources/singleResource';

export const getProductCharacteristic = (account: CustomerAccount, name: string): string => {
	const productCharacteristic = account?.product.productCharacteristic.find((element) => element.name === name);
	return productCharacteristic?.value || '';
};

export const getResourceCharacteristicValue = (
	resources: SingleResource[],
	specification: string,
	name: string
): string => {
	const resource = (resources || []).find((element) => element.resourceSpecification.name === specification);
	if (!resource || !resource.resourceCharacteristicValue) {
		return '';
	}
	const characteristic = resource?.resourceCharacteristicValue.find((element) => element.name === name);
	return characteristic?.value || '';
};
